import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Arrow } from '../arrow/Arrow';
import styles from './BackArrow.module.scss';

interface BackArrowProps {
    url?: string,
    text?: string
}

export const BackArrow = ({ url, text } : BackArrowProps) => {
    const history = useHistory();
    const { t } = useTranslation();
    
    const displayText = text ? text : t('Util.Back');
    
    if (url) {
        return (
            <Link to={url} className={styles.link} aria-label={displayText}>
                <span className={styles.container}>
                    <span className={styles.arrow_container} aria-hidden="true">
                        <Arrow size='small' direction='left' color='blue' />
                    </span>
                    <span className={styles.back_text}>{displayText}</span>
                </span>
            </Link>
        )
    } else {
        return (
            <button 
                type="button"
                onClick={() => history.goBack()} 
                className={styles.link}
                aria-label={displayText}
            >
                <span className={styles.container}>
                    <span className={styles.arrow_container} aria-hidden="true">
                        <Arrow size='small' direction='left' color='blue' />
                    </span>
                    <span className={styles.back_text}>{displayText}</span>
                </span>
            </button>
        )
    }
};